// ─── Python backend (data / analysis) ────────────────────
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const API_ENDPOINTS = {
  survivalAnalysis: `${API_BASE_URL}/survival-analysis`,
  filtersData:      `${API_BASE_URL}/filters-data`,
  health:           `${API_BASE_URL}/health`,
  safetyProfile:    `${API_BASE_URL}/safety-profile`,
};

// ─── Node RBAC backend (auth / user management) ───────────
export const RBAC_BASE_URL = process.env.REACT_APP_RBAC_URL || 'http://localhost:4000';

export const RBAC_ENDPOINTS = {
  login:          `${RBAC_BASE_URL}/api/auth/login`,
  logout:         `${RBAC_BASE_URL}/api/auth/logout`,
  refreshToken:   `${RBAC_BASE_URL}/api/auth/refresh-token`,
  me:             `${RBAC_BASE_URL}/api/auth/me`,
  acceptTerms:    `${RBAC_BASE_URL}/api/auth/accept-terms`,
  forgotPassword: `${RBAC_BASE_URL}/api/auth/forgot-password`,
  resetPassword:  `${RBAC_BASE_URL}/api/auth/reset-password`,
  users:          `${RBAC_BASE_URL}/api/users`,
  roles:          `${RBAC_BASE_URL}/api/roles`,
  filtersConfig:   `${RBAC_BASE_URL}/api/filters/config`,
  auditLogs:       `${RBAC_BASE_URL}/api/audit-logs`,
  engagementReport: `${RBAC_BASE_URL}/api/audit-logs/engagement-report`,
  moduleView:      `${RBAC_BASE_URL}/api/audit-logs/module-view`,
  sessionPing:     `${RBAC_BASE_URL}/api/audit-logs/session-ping`,
  changePassword:  `${RBAC_BASE_URL}/api/auth/change-password`,
  syncPreview:     `${RBAC_BASE_URL}/api/sync/preview`,
  syncImport:      `${RBAC_BASE_URL}/api/sync/import`,
  userAssignments: (id) => `${RBAC_BASE_URL}/api/users/${id}/assignments`,
  userHospitals:   (id) => `${RBAC_BASE_URL}/api/users/${id}/hospitals`,
  metaHospitals:   `${RBAC_BASE_URL}/api/users/meta/hospitals`,
  metaZones:       `${RBAC_BASE_URL}/api/users/meta/zones`,
  metaSalesReps:   `${RBAC_BASE_URL}/api/users/meta/sales-reps`,
  metaZBMs:        `${RBAC_BASE_URL}/api/users/meta/zbms`,
  // metaZBMs:        `${RBAC_BASE_URL}/api/users/meta/zbms`,
  patientDeepDive: `${RBAC_BASE_URL}/api/patients/deep-dive`,
  milestones:        `${RBAC_BASE_URL}/api/milestones`,
  milestonesExport:  `${RBAC_BASE_URL}/api/milestones/export`,
  milestonesFilters: `${RBAC_BASE_URL}/api/milestones/filters`,
  // Campaigns
  campaigns:           `${RBAC_BASE_URL}/api/campaigns`,
  campaignTemplates:   `${RBAC_BASE_URL}/api/campaigns/templates`,
  campaignTemplate:    (type) => `${RBAC_BASE_URL}/api/campaigns/templates/${type}`,
  campaignDetail:      (id) => `${RBAC_BASE_URL}/api/campaigns/${id}`,
  campaignRecipients:  (id) => `${RBAC_BASE_URL}/api/campaigns/${id}/recipients`,
  campaignRecipientsExport: (id) => `${RBAC_BASE_URL}/api/campaigns/${id}/recipients/export`,
  campaignTestSend:    (id) => `${RBAC_BASE_URL}/api/campaigns/${id}/test-send`,
  campaignConfirm:     (id) => `${RBAC_BASE_URL}/api/campaigns/${id}/confirm`,
  campaignSend:        (id) => `${RBAC_BASE_URL}/api/campaigns/${id}/send`,
  campaignPause:       (id) => `${RBAC_BASE_URL}/api/campaigns/${id}/pause`,
  campaignRetry:       (id) => `${RBAC_BASE_URL}/api/campaigns/${id}/retry`,
  campaignSystemStatus: `${RBAC_BASE_URL}/api/campaigns/system-status`,

  // Retry queue for system emails about individual accounts
  emailOutbox:      `${RBAC_BASE_URL}/api/email-outbox`,
  emailOutboxRetry: (id) => `${RBAC_BASE_URL}/api/email-outbox/${id}/retry`,
  // CAR-T Playbook
  playbookHospitals:    `${RBAC_BASE_URL}/api/playbook/hospitals`,
  playbookPhysicians:   `${RBAC_BASE_URL}/api/playbook/physicians`,
  playbookPatients:     `${RBAC_BASE_URL}/api/playbook/patients`,
  playbookPatientSearch:`${RBAC_BASE_URL}/api/playbook/patients/search`,
  playbookPatient:      (id) => `${RBAC_BASE_URL}/api/playbook/patients/${id}`,
  playbookCases:        `${RBAC_BASE_URL}/api/playbook/cases`,
  playbookCase:         (id) => `${RBAC_BASE_URL}/api/playbook/cases/${id}`,
  playbookCaseArchive:  (id) => `${RBAC_BASE_URL}/api/playbook/cases/${id}/archive`,
  playbookCaseRestore:  (id) => `${RBAC_BASE_URL}/api/playbook/cases/${id}/restore`,
  playbookCaseDelete:        (id) => `${RBAC_BASE_URL}/api/playbook/cases/${id}/delete`,
  playbookCaseRestoreDeleted:(id) => `${RBAC_BASE_URL}/api/playbook/cases/${id}/restore-deleted`,
  playbookCaseExport:   (id) => `${RBAC_BASE_URL}/api/playbook/cases/${id}/export`,
};

export default API_BASE_URL;
